import React from "react";
import { useI18n } from "../i18n/I18nProvider";
import CategoryMedia from "./CategoryMedia";

const MobileCategoryLanding = ({ parents, onSelect, onDisabledClick }) => {
    const { t } = useI18n();
    const labelOf = (p) => {
        const tr = t(p.name_key);
        return tr && tr !== p.name_key ? tr : p.label;
    };
    // Hide empty parents entirely (user spec).
    parents = parents.filter((p) => !p.disabled);
    const totalItems = parents.reduce((s, p) => s + (p.items || 0), 0);

    return (
        <section
            data-testid="mobile-category-landing"
            className="px-4 py-6 md:hidden"
        >
            <h2 className="font-display text-2xl tracking-tight font-medium mb-1">
                {t("section_shop_by_category")}
            </h2>
            <p className="text-sm text-neutral-500 mb-5">
                {t("section_select_category")}
            </p>

            <div className="grid grid-cols-2 gap-3">
                {parents.map((p) => {
                    const label = labelOf(p);
                    if (p.disabled) {
                        return (
                            <button
                                key={p.id}
                                type="button"
                                data-testid={`mobile-parent-${p.id}-disabled`}
                                onClick={() => onDisabledClick(label)}
                                aria-disabled="true"
                                className="relative bg-neutral-50 border border-dashed border-neutral-300 rounded-2xl p-4 flex flex-col items-start gap-2 text-left opacity-70 cursor-not-allowed"
                            >
                                <span className="absolute top-2 right-2 text-[9px] font-bold uppercase tracking-wider bg-neutral-900 text-white px-1.5 py-0.5 rounded">
                                    {t("category_coming_soon")}
                                </span>
                                <CategoryMedia parent={p} size="h-14 w-14" grayscale />
                                <div>
                                    <div className="font-semibold text-sm text-neutral-500 leading-tight line-clamp-2">
                                        {label}
                                    </div>
                                    <div className="text-[11px] text-neutral-400 mt-0.5">
                                        {t("category_coming_soon")}
                                    </div>
                                </div>
                            </button>
                        );
                    }
                    return (
                        <button
                            key={p.id}
                            data-testid={`mobile-parent-${p.id}`}
                            onClick={() => onSelect(p.id)}
                            className="bg-white border border-neutral-200 rounded-2xl p-2.5 flex flex-col gap-2 hover:border-[#FF5722] active:scale-95 transition-all"
                        >
                            <CategoryMedia parent={p} size="aspect-square w-full" />
                            <div className="font-semibold text-sm text-neutral-900 leading-tight text-center px-1 pb-1 mt-auto line-clamp-2">
                                {label}
                            </div>
                        </button>
                    );
                })}
            </div>

            <p className="text-[11px] text-neutral-400 mt-5 text-center">
                {totalItems} {t("filter_all").toLowerCase()} · {parents.filter((p) => !p.disabled).length} {t("section_shop_by_category").toLowerCase()}
            </p>
        </section>
    );
};

export default MobileCategoryLanding;
